import { post, put, get } from 'axios'

const CONFIRM_USER_ROUTE = 'users/confirm/'

function initialState() {
  return {
    confirmRegister: {
      form: {
        password: undefined,
        email: undefined,
        googleRecaptcha: undefined,
        token: undefined,
      },
      message: undefined,
    },
  }
}

function formatToSend(data) {
  return {
    password: data.password,
    authToken: data.token,
  }
}

const state = initialState()

const getters = {
  confirmRegister: state => state.confirmRegister,
}

const actions = {
  confirmRegister({ state }) {
    const dataFormated = formatToSend(state.confirmRegister.form)

    return put(CONFIRM_USER_ROUTE, dataFormated).then(() => {
      return post('/auth/login', state.confirmRegister.form).then(response => {
        return response.data.token
      })
    })
  },

  updateMessage(state, message) {
    state.confirmRegister.message = message
  },

  requestData() {
    return get(CONFIRM_USER_ROUTE + '/' + this.$route.params.token)
  },

  clearPassword(state) {
    state.confirmRegister.form.password = undefined
  },

  // eslint-disable-next-line no-unused-vars
  reset({ state }) {
    state = initialState()
  },
}

const mutations = {
  updateConfirmRegisterForm(state, properties) {
    state.confirmRegister.form[properties.property] = properties.value
  },

  updateMessage(state, message) {
    state.confirmRegister.message = message
  },

  saveJWT(state, jwt) {
    localStorage.jwt = jwt
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
